import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Local class-name merger so the package does not depend on the host app's
 * `@/lib/utils`. Same implementation, kept inside the package for portability.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
